let requestSendBtns = document.querySelectorAll('.request-send')

if(requestSendBtns.length) {
    for(let requestSend of requestSendBtns) {
        requestSend.addEventListener('click', (e) => {
            e.preventDefault()
    
            let elem = requestSend
            let form = elem.closest('form')
            let popup = elem.closest('.popup')
            let fields = {
                name: 1,
                email: 0,
                phone: 1,
                message: 0,
            }
            let data = {}
            let errors = 0
        
            for(let key in fields) {
                let required = fields[key]
                let field = form.querySelector('.' + key)
        
                if(field) {
                    let value = field.getValue()
        
                    if(required) {
                        errors += field.check()
                    }
        
                    data[key] = value
                }
            }
        
            if(!errors) {
                elem.disable(true)
    
                requestAxios('sendOrder', data, (res) => {

                    elem.enable()
    
                    for(let key in fields) {
                        let field = form.querySelector('.' + key)
                
                        if(field) {
                            if(field.mask) {
                                field.mask.unmaskedValue = ''
                            } else {
                                field.value = ''
                            }
                        }
                    }
    
                    closePopup(popup)
    
                    add_notif({
                        title: 'Спасибо',
                        text: 'Ваша заявка была отправлена, мы скоро свяжемся с вами.',
                        timeout: 7000,
                        icon: 'success'
                    })
                })
            }
        })
    }
}

let subscribeSend = document.querySelector('.subscribe-send')

if(subscribeSend) {
    subscribeSend.addEventListener('click', (e) => {
        e.preventDefault()

        let elem = subscribeSend
        let form = elem.closest('form')
        let fields = {
            email: 1,
            agree: 1,
        }
        let data = {}
        let errors = 0
    
        for(let key in fields) {
            let required = fields[key]
            let field = form.querySelector('.' + key)
    
            if(field) {
                let value = field.getValue()
    
                if(required) {
                    errors += field.check()
                }
    
                data[key] = value
            }
        }
    
        if(!errors) {
            elem.disable(true)

            requestAxios('sendOrder', data, () => {
                elem.enable()

                for(let key in fields) {
                    let field = form.querySelector('.' + key)
            
                    if(field) {
                        if(field.mask) {
                            field.mask.unmaskedValue = ''
                        } else {
                            field.value = ''
                        }
                    }
                }

                add_notif({
                    title: 'Спасибо',
                    text: 'Ваша заявка была отправлена.',
                    timeout: 7000,
                    icon: 'success'
                })
            })
        }
    })
}

let consSend = document.querySelectorAll('.cons-send')

if(consSend.length) {
    for(let btn of consSend) {
        btn.addEventListener('click', (e) => {
            e.preventDefault()
    
            let elem = btn
            let form = elem.closest('form')
            let fields = {
                phone: 1,
            }
            let data = {}
            let errors = 0
        
            for(let key in fields) {
                let required = fields[key]
                let field = form.querySelector('.' + key)
        
                if(field) {
                    let value = field.getValue()
        
                    if(required) {
                        errors += field.check()
                    }
        
                    data[key] = value
                }
            }
        
            if(!errors) {
                elem.disable(true)
    
                requestAxios('sendOrder', data, () => {
                    elem.enable()
    
                    for(let key in fields) {
                        let field = form.querySelector('.' + key)
                
                        if(field) {
                            if(field.mask) {
                                field.mask.unmaskedValue = ''
                            } else {
                                field.value = ''
                            }
                        }
                    }
    
                    add_notif({
                        title: 'Спасибо',
                        text: 'Ваша заявка была отправлена.',
                        timeout: 7000,
                        icon: 'success'
                    })
                })
            }
        })
    }
}